<template>
    <div id="earned-points">
        <img src="@/assets/images/star-award.svg" alt="Star Award" />
        <span class="ml-1 align-middle">
            <template v-if="isOrderCompleted">
                You have earned <span class="font-weight-bold">{{ points | formatted }}</span>.
            </template>
            <template v-else>
                Earn <span class="font-weight-bold">{{ points | formatted }}</span> after order completion.
            </template>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        points: {
            type: Number,
            default: 0
        },
        isOrderCompleted: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatted(value) {
            return `${value} point${value > 1 ? 's' : ''}`
        }
    }
}
</script>

<style lang="scss" scoped>
#earned-points {
    background-color: rgba(255, 248, 233, 0.75);
    border: 1px solid #FEEC99;
    padding: 9px 16px;
    border-radius: 6px;
    font-size: 1rem;
}
</style>